import { createFileRoute } from "@tanstack/react-router";
import WhyUs from "@/pages/WhyUs";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de-ce-noi/")({
  head: () => routeHead("/de-ce-noi/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <WhyUs />
  );
}
